<template>
<section>

	<!---================contact-banner-start=======================---->
	<div class="contact-banner"></div>
	<!---================contact-banner-end=======================---->

	<div class="contact-section">
		<div class="container">
			<div class="row">
				<div class="col-md-4">
					<div class="contact-left">
						<h1>Contact WeVisu</h1>
						<p>Our support team is available for all of your inquiries.<br><br> Thank you for your business!</p>
							<!-- <a href="tel:8003944413"><span><img src="images/phone-icon.png"></span>(800) 394-4413</a> -->
							<a href="mailto:support@wevisu.com">
								<!-- <span><img src="images/mail-white.png"></span> -->
								support@wevisu.com</a>

							<!-- <a href="javascript:void()" class="supportchat-btn">Live Chat</a> -->
						</div>
					</div>
					<div class="col-md-8">
						<div class="contact-right ">
							<div class="loginRegSection">
							<form @submit.prevent="submit_contact()">
								<div class="row vld-parent" id="contact_main_ref">
									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('email') ,'haveValue': form.name }">
											<input type="text" class="form-control" v-model="form.name">
											<span class="label">Name</span>
											<has-error :form="form" field="name" class="errormsg"></has-error>
										</label>

									</div>

									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('ordernumber'),'haveValue': form.ordernumber }">
											<input type="text" class="form-control" v-model="form.ordernumber">
											<span class="label">Order number</span>
											<has-error :form="form" field="ordernumber" class="errormsg"></has-error>
										</label>
									</div>

									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('email'), 'haveValue': form.email }">
											<input type="email" class="form-control" v-model="form.email">
											<span class="label">Email address</span>
											<has-error :form="form" field="email" class="errormsg"></has-error>
										</label>
									</div>

									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('reason'), 'haveValue': form.reason }">
											<input type="text" v-model="form.reason" class="form-control select">
											<span class="label w-100">Reason for request</span>

											<div class="selectDropDown">
												<ul class="list-unstyled">
													<li @click="form.reason='Design Problems'">Design Problems</li>
													<li @click="form.reason='WeVisu Support'">WeVisu Support</li>
													<li @click="form.reason='Other'">Other</li>
												</ul>
											</div>
											<has-error :form="form" field="reason" class="errormsg"></has-error>
										</label>

									</div>

									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('phone'), 'haveValue': form.phone }">
											<input type="rel" v-model="form.phone" class="form-control">
											<span class="label">Phone number</span>
											<has-error :form="form" field="phone" class="errormsg"></has-error>
										</label>

									</div>

									<div class="col-md-6">
										<label class="inputWrpr" :class="{ 'error': form.errors.has('message'), 'haveValue': form.message }">
											<input type="text" v-model="form.message" class="form-control">
											<span class="label">Message</span>
											<has-error :form="form" field="message" class="errormsg"></has-error>
										</label>

									</div>

									<div class="col-md-12">
										<input type="submit" class="btn btn-primary" value="Send">
									</div>


								</div>
							</form>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="contact-bottom">
				<div class="container">
					<div class="row">
						<div class="col-md-12">
							<div class="whiteBgContent">
							<div class="testimonial-slider">
								<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
									<!-- <ol class="carousel-indicators">
										<li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
										<li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
										<li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
									</ol> -->
									<div class="carousel-inner">
										<div class="carousel-item active">
											<p class="text-center">“Live 3D rendering makes replacing materials easier to visualize!“</p>
										</div>
										<div class="carousel-item">
											<p class="text-center">“Enter your contractor/designers' personal ID# to see their Virtual Showrooms!“</p>
										</div>
										<div class="carousel-item">
											<p class="text-center">“Contractors and designers find the best materials and at the best prices to display inside their virtual showrooms.“</p>
										</div>
									</div>
								</div>
							</div>
							</div>
						</div>
						<!-- <div class="col-md-6">
							<div class="contact-featured-img">
								<figure><img src="images/contact-right-img.jpg"></figure>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>


</section>

</template>

<script>

export default {
    name: 'Contactus',
    components: {

    },
    data() {
        return {
            form: new Form({
                    name: '',
					ordernumber:'',
                    email:'',
					reason:'',
                    phone:'',
                    message:''
                })
        }
    },
    watch: {

    },
    computed: {
    },

    mounted() {
         this.$nextTick(function () {

         })
    },

    updated: function () {
        this.$nextTick(function () {
        })
    },
    methods: {
  submit_contact(){
       let loader=  this.$loading.show({loader:'dots',container: this.$refs.contact_main_ref})
                this.form.post('api/contactus')
                .then((data)=>{
                    loader.hide()
                	this.form.reset();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                })
                .catch(err=>{
                     loader.hide()
                })
            }

    },

    filters: {

    }
};
</script>
